import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import Logo from "./Logo";

export default function PageLoading() {
  const isLoading = useSelector((state) => state?.common?.isLoading ?? false);
  return (
    <div>
      {isLoading && (
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}
          open={Boolean(isLoading)}
        >
          <div className="relative">
            <div className="relative">
              <Logo className="transform translate-y-2" />
            </div>
            <div className="absolute top-0 w-full h-full">
              <CircularProgress className="w-full h-full" />
            </div>
          </div>
        </Backdrop>
      )}
    </div>
  );
}
